export enum IEntitiesTypes {
  GET_COUNTRIES_LIST_SUCCESS = 'GET_COUNTRIES_LIST_SUCCESS',
}
